"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var styles = exports.styles = function styles(props) {
  var openCategories = props.openCategories;
  var topBarClasses = (0, _classnames2.default)({
    top: true,
    "pad-8": true,
    "pos-r": true
  });
  var menuItemClasses = (0, _classnames2.default)({
    "menu-item": true,
    "ls-1": true,
    "d-block": true,
    "pad-16": true,
    "pos-r": true
  });
  var plusSignClasses = (0, _classnames2.default)({
    far: true,
    "pos-a": true,
    "right-0": true,
    "mar-t-2": true,
    "mar-r-16": true
  });
  var childCategoryListClasses = (0, _classnames2.default)({
    "mar-0": true,
    "lsts-none": true,
    "pad-0": true,
    "pad-l-20": true
  });
  var childCategoryClasses = (0, _classnames2.default)({
    "ls-1": true,
    "pad-16": true
  });
  var closeButtonClasses = (0, _classnames2.default)({
    "burger-menu-close-button": true,
    "pos-a": true,
    "fs-36": true,
    "fw-bold": true,
    "naked-button": true,
    "pad-0": true
  });
  return {
    topBarClasses: topBarClasses,
    menuItemClasses: menuItemClasses,
    plusSignClasses: plusSignClasses,
    childCategoryListClasses: childCategoryListClasses,
    childCategoryClasses: childCategoryClasses,
    closeButtonClasses: closeButtonClasses
  };
};

exports.default = styles;